import posthog from 'posthog-js';

const key = process.env.REACT_APP_POSTHOG_KEY;
const host =
  process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';

export function initPosthog() {
  if (!key) return;
  posthog.init(key, {
    api_host: host,
    person_profiles: 'identified_only',
  });
  posthog.register({ app_name: 'cv_analyzer' });
}

export { posthog };
